<template>
  <div>
    <div
      class="
        text-left
        sm:fixed
        border-t border-solid border-gray-200
        bottom-0
        h-auto
        mt-32
        w-full
        block
        dark:bg-purple-600
        sm:bg-gray-100
        privacy_width
      "
    >
      <div class="container">
        <div class="block sm:hidden">
          <a
            class="border-b border-solid border-gray-200 border-b-2 font-medium"
            href="https://carleton.ca/"
            title="Carleton University Homepage"
          >
            <div v-if="$store.state.darkMode">
              <div class="newlogo-mobile-dark"></div>
            </div>
            <div v-else>
              <div class="newlogo-mobile"></div>
            </div>
          </a>
        </div>
        <p
          class="
            dark:text-white
            text-sm
            sm:text-xs sm:text-right
            p-6
            sm:float-left
            text-center
            hidden
            sm:block
          "
        >
          <a
            class="border-b border-solid border-gray-200 border-b-2 font-medium"
            href="https://carleton.ca/"
            title="Carleton University Homepage"
            >Carleton University</a
          >
        </p>

        <p
          class="
            dark:text-white
            text-sm
            sm:text-xs
            text-center
            p-6
            md:float-right
          "
        >
          <a
            class="border-b border-solid border-gray-200 border-b-2 font-medium"
            href="https://carleton.ca/privacy/policies/"
            >Privacy Policy</a
          >
          &nbsp;
          <a
            class="border-b border-solid border-gray-200 border-b-2 font-medium"
            href="https://carleton.ca/accessibility/"
            >Accessibility</a
          >
          &nbsp; &copy;
          <span class="font-medium">Copyright {{ new Date().getFullYear() }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarletonFooter.vue",
};

</script>

<style scoped></style>
